















































































































































import { Component, Vue } from 'vue-property-decorator'
import { CommonModule } from '../../store'
import { userTypeOptions } from '../../utils/selectOptions'
import { OptionItemType, UserInfoType, OperationItemType } from '../../types/type'
@Component({
  name: 'AddOrUpdateUser',
  components: {
    'concise-card-have-title-acquiescent': () => import('../../components/common/conciseCardHaveTitleAcquiescent.vue')
  }
})
export default class AddOrUpdateUser extends Vue {
  public id: any = ''
  public isOnlyLook: boolean = false
  public belongTo: any[] = []
  public pageTitle: string = ''
  public expofPhone: RegExp = /^1[3-9]\d{9}$/
  public loading: boolean = false
  public userInfo: UserInfoType = {
    username: '',
    card: '',
    phone: '',
    organizationId: '',
    password: '',
    descr: '',
    userType: '',
    position: '',
    enable: false
  }
  public userTypeOptions: OptionItemType[] = userTypeOptions
  public administrativeOfficeList: OptionItemType[] = []
  public operationForButtonOfTableHeader: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-caret-left m_r5'></span>返回",
      key: 'back',
      type: 'primary',
      size: ''
    }
  ]

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  async getOptions (ekey) {
    return new Promise(async (resolve, reject) => {
      try {
        let _that: any = this
        let { data: result } = await _that.$http.enumSelectList({ key: ekey })
        if (result.code !== 200) return this.$message.error(result.msg)
        let res = result.data
        switch (ekey) {
          case 'position':
            this.administrativeOfficeList = res
            break
        }
        resolve(true)
      } catch (err) {
        console.log(err)
      }
    })
  }

  async created () {
    if (!this.$route.query.id) return this.$router.back()
    this.id = this.$route.query.id
    this.pageTitle = '新增用户'
    await CommonModule.getTreeDataForSubOrganization()
    await Promise.all([this.getOptions('position')])
    if (this.id !== 'add') {
      this.pageTitle = '编辑用户'
      this.getSysUserInfo()
      if (this.$route.query.readOnly === 'true') {
        this.pageTitle = '用户详情'
        this.isOnlyLook = true
      }
    }
  }

  getAllFatherNode (id) {
    function treeFindPath (tree, func, path = []) {
      if (!tree) return []
      for (const data of tree) {
        // 这里按照你的需求来存放最后返回的内容吧
        path.push(data)
        if (func(data)) return path
        if (data.children) {
          const findChildren = treeFindPath(data.children, func, path)
          if (findChildren.length) return findChildren
        }
        path.pop()
      }
      return []
    }
    let result = treeFindPath(this.treeDataForSubOrganatizion, data => data.id === id)
    return result.map(item => item.id)
  }

  async getSysUserInfo () {
    try {
      let _that: any = this
      this.loading = true
      let { data: result } = await _that.$http.getSysUserInfo({ id: this.id })
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      let info = result.data
      Object.keys(this.userInfo).forEach(item => {
        if (item === 'organizationId') {
          this.belongTo = this.getAllFatherNode(info[item])
        }
        this.userInfo[item] = info[item]
      })
    } catch (err) {
      console.log(err)
    }
  }

  async save () {
    try {
      let _that: any = this
      this.userInfo.organizationId =
        this.belongTo && this.belongTo.length
          ? this.belongTo[this.belongTo.length - 1]
          : ''
      let res = Object.keys(this.userInfo).some(item => {
        if (this.userInfo[item] === '') {
          return item
        }
      })
      if (res) return this.$message.warning('信息填写不完整，请核对信息')
      if (this.userInfo['card'].length !== 18) return this.$message.warning('身份证号必须为18位')
      if (!this.expofPhone.test(this.userInfo['phone'])) return this.$message.error('手机号格式不正确')
      let params = this.userInfo
      let message = '新增成功'
      let apiName = ''
      if (this.id !== 'add') {
        message = '编辑成功'
        delete params.password
        Object.assign(params, { id: this.id })
        apiName = 'sysUserUpdate'
      } else {
        apiName = 'sysUserSave'
      }

      var { data: result } = await _that.$http[apiName](params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(message)
      setTimeout(() => {
        this.$router.push({
          name: 'UserManagement',
          query: { refresh: 'refresh' }
        })
      }, 500)
    } catch (err) {
      console.log(err)
    }
  }

  // 操作按钮：
  operationForButton ({ key }) {
    switch (key) {
      case 'back':
        this.$router.push({ name: 'UserManagement' })
        break
    }
  }
}
